// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__28w63","boxTitle":"Qualiphy_boxTitle__FOj1U","box":"Qualiphy_box__15NAN","toggleWrap":"Qualiphy_toggleWrap__2lkdN"};